import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControllerSelectorComponent } from './controller-selector/controller-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberSettingsComponent } from './controller-selector/settings/number-settings/number-settings.component';
import { GISSettingsComponent } from './controller-selector/settings/gis-settings/gis-settings.component';
import { LunaCommonModule } from "../../../../../../common/common.module";
import { AccordionModule } from "../../../../../../common/components/accordion/accordion.module";
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule,
        ReactiveFormsModule,
        LunaCommonModule, 
        AccordionModule
    ],
    declarations: [
        ControllerSelectorComponent,
        NumberSettingsComponent,
        GISSettingsComponent
    ],
    exports: [
        ControllerSelectorComponent,
        NgSelectComponent
    ]
})
export class CommonConfigModule { }
